window.addEventListener('DOMContentLoaded', () => {
    const backToTopButton = document.querySelector(".back-to-top-btn");
    if (backToTopButton) {
        backToTopButton.onclick = () =>
            document.documentElement.scroll({
                top: 0,
                behavior: "smooth"
            });
        window.onscroll = () => {

        if (document.documentElement.scrollTop > 60) {
            backToTopButton.classList.remove("hidden");
        } else {
            backToTopButton.classList.add("hidden");
        }
    };
}
});